import { FC } from 'react';

import { ImageConfig } from 'molecules/Image/config';

import Image from '.';

const RichTextImage: FC<ImageConfig> = ({ image }) =>
  image && (
    <Image
      className="block w-full overflow-hidden rounded-lg"
      {...image.file}
      alt={image.alt || ''}
      url={image.file?.url}
    />
  );

export default RichTextImage;
